import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { insuranceApi } from "../store/insurance/actions";
export var useGetInsurance = function (trigger, sponsorId, descriptionInsurance, projectType) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(100), limit = _c[0], setLimit = _c[1];
    var dispatch = useDispatch();
    var _d = useSelector(function (state) {
        var _a;
        return ({
            responseInsurance: (_a = state.Insurance.responseInsurance) === null || _a === void 0 ? void 0 : _a.data,
            errorInsurance: state.Insurance.errorInsurance,
            loadingInsurance: state.Insurance.loadingInsurance,
        });
    }), responseInsurance = _d.responseInsurance, errorInsurance = _d.errorInsurance, loadingInsurance = _d.loadingInsurance;
    useEffect(function () {
        if (trigger) {
            dispatch(insuranceApi({
                enable: enable,
                page: page,
                limit: limit,
                sponsorId: sponsorId,
                descriptionInsurance: descriptionInsurance,
                // projectType: projectType,
            }));
        }
    }, [sponsorId, descriptionInsurance, projectType, trigger]);
    return {
        responseInsurance: responseInsurance,
        errorInsurance: errorInsurance,
        loadingInsurance: loadingInsurance,
        setEnable: setEnable,
        setPage: setPage,
        setLimit: setLimit,
    };
};
